import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import { AgentsRoutePage } from "../app/agentsRoute";

export const Route = createFileRoute("/agents")({
  component: AgentsRoute,
});

function AgentsRoute(): JSX.Element {
  const search = Route.useSearch();
  return <AgentsRoutePage search={search} />;
}
